import { Pipe, PipeTransform } from '@angular/core';
import { ImageUrlService } from '@frontend/common';

/**
 * The default avatar shown when a user has no avatar of their own (or is
 * anonymity-restricted, arriving with all avatar fields null).
 */
export const DEFAULT_AVATAR_URL =
  'https://res.cloudinary.com/cebt/image/upload/v1616972586/users/avatars/default-avatar.gif';

/** A user-like object carrying the denormalised `(avatar_disk, avatar_path)` pair. */
export interface UserAvatarSource {
  avatar_disk?: string | null;
  avatar_path?: string | null;
}

/**
 * Builds a user's avatar delivery URL from the denormalised `avatar_disk` /
 * `avatar_path` pair, via {@link ImageUrlService}. Falls back to the shared
 * default-avatar image when the user has no avatar (or is anonymity-restricted).
 *
 * `{{ user | userAvatar:'w_48,h_48,c_thumb,g_face' }}`
 */
@Pipe({ name: 'userAvatar', standalone: true })
export class UserAvatarPipe implements PipeTransform {
  constructor(private imageUrlService: ImageUrlService) {}

  transform(user: UserAvatarSource | null | undefined, transform?: string): string {
    if (user?.avatar_path) {
      const url = this.imageUrlService.build(
        { disk: user.avatar_disk, path: user.avatar_path },
        transform
      );
      if (url) {
        return url;
      }
    }
    return DEFAULT_AVATAR_URL;
  }
}
